import { render, staticRenderFns } from "./insurance.vue?vue&type=template&id=a018c36c&scoped=true"
import script from "./insurance.vue?vue&type=script&lang=js"
export * from "./insurance.vue?vue&type=script&lang=js"
import style0 from "./insurance.vue?vue&type=style&index=0&id=a018c36c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a018c36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a018c36c')) {
      api.createRecord('a018c36c', component.options)
    } else {
      api.reload('a018c36c', component.options)
    }
    module.hot.accept("./insurance.vue?vue&type=template&id=a018c36c&scoped=true", function () {
      api.rerender('a018c36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/insurance.vue"
export default component.exports